import type { ComponentPropsOptions, PropType } from "vue";
import type { IntrinsicComponent } from "@/types/components";
import { defineComponent, h } from "vue";
import { cn } from "@/utils/cn";

const props = {
  as: {
    type: String as PropType<keyof HTMLElementTagNameMap>,
  },
} satisfies ComponentPropsOptions;

export function createTypographyComponent<El extends keyof HTMLElementTagNameMap = "div">(
  el: El,
  classes: string
): IntrinsicComponent<El, typeof props> {
  return defineComponent({
    name: el.toUpperCase(),
    props,
    setup(props, { slots, attrs }) {
      return () => h(props.as || el, { ...attrs, class: cn(classes, attrs.class ?? "") }, slots);
    },
  }) as any;
}
